// Tiny toast queue. Components subscribe via the Toaster mount.
import { useSyncExternalStore } from 'react';

export type ToastKind = 'info' | 'ok' | 'error' | 'warn';
export interface Toast { id: number; kind: ToastKind; message: string; ttl: number }

let toasts: Toast[] = [];
let nextId = 1;
const subscribers = new Set<() => void>();

function emit() { subscribers.forEach((s) => s()); }

function push(kind: ToastKind, message: string, ttl = 2800) {
  const t: Toast = { id: nextId++, kind, message, ttl };
  toasts = [...toasts, t];
  emit();
  setTimeout(() => {
    toasts = toasts.filter((x) => x.id !== t.id);
    emit();
  }, ttl);
}

export const toastApi = {
  info:  (msg: string) => push('info',  msg),
  ok:    (msg: string) => push('ok',    msg),
  error: (msg: string) => push('error', msg, 4000),
  warn:  (msg: string) => push('warn',  msg),
  dismiss: (id: number) => { toasts = toasts.filter((t) => t.id !== id); emit(); },
};

export function useToast() {
  return toastApi;
}

export function useToasts() {
  return useSyncExternalStore(
    (cb) => { subscribers.add(cb); return () => subscribers.delete(cb); },
    () => toasts,
    () => toasts,
  );
}
